module.exports = __webpack_public_path__ + "static/media/arrowLeftGray.79d9fa20.svg";